import { useContext } from 'react';
import { RequestsContext } from '../contexts/requestsContext';

export const useRequestsContext = () => useContext(RequestsContext);
